import {useEffect, useState} from "react";
import {DropdownCloseSVG, DropdownOpenSVG} from "../../../../svg"
import classNames from "classnames";
import {FormattedMessage} from "react-intl";

interface IWidgetSmartSearch {

    listItem: Array<any>
    stepId: any
    setStepId: (x: number) => void,
    disabled?: boolean
    forStep?: number
    setStep?: (step: number) => void
    title?:string
    defaultMessage?:string
}

const WidgetSmartSearch = (props: IWidgetSmartSearch) => {


    const {listItem, stepId, setStepId, disabled = false, forStep = 0, setStep,title,defaultMessage=""} = props

    const [opened, setOpened] = useState<boolean>(false)
    const [enteredItem, setEnteredItem] = useState<string>("")


    const handleOpen = () => {
        setOpened(!opened)
    }

    useEffect(() => {
        setEnteredItem(stepId?.name || "")
    }, [stepId])

    useEffect(() => {
        document.addEventListener("click", closeWhenDocumentClick)

        return () => {
            document.removeEventListener("click", closeWhenDocumentClick)
        }
    }, [opened])

    const closeWhenDocumentClick = () => {
        if (opened) {
            setOpened(false)
        }

    }
    const handleChooseOption = ((el: any) => {

        if (stepId?.id !== el.id) {
            setStepId(el)
            setEnteredItem(el.name)
            if (setStep) {
                setStep(forStep)
            }
        }
        setOpened(false)
    })


    const className = classNames("", {
        "smart-search-opened-sort": forStep !== 1,
        "smart-search-opened-sort-step-one": forStep === 1
    })

    const optionalItems = listItem.map(el => {

        return <>
            <div className={`smart-search-sort-option`} onClick={() => handleChooseOption(el)}>
            <span>
                {el.name}
            </span>
            </div>
        </>
    })
    return <>

        <div className="smart-search-sort-container">
            {forStep === 1 ?
                <div className={"search-smart-for-step-one"} onClick={() => !disabled ? handleOpen() : null}>


                        <div className="search-smart-enabled">
                            <span>{enteredItem}</span>

                            <div>
                                {opened ? <DropdownOpenSVG/> : <DropdownCloseSVG/>}
                            </div>
                        </div>

                </div>

                :
                <div>
                    <div>
                        <span>
                        <FormattedMessage id={title} defaultMessage={defaultMessage} />
                        </span>
                    </div>
                    <div className="smart-search-sort-wrapper">

                        <div className="smart-search-sort" onClick={() => !disabled ? handleOpen() : null}>
                            {!disabled ?
                                <>
                                    <div className="search-smart-enabled">
                                        <span>{enteredItem}</span>

                                        <div>
                                            {opened ? <DropdownOpenSVG/> : <DropdownCloseSVG/>}
                                        </div>
                                    </div>

                                </>
                                :
                                <>
                                    <div className="search-smart-disabled">
                                        <div>
                                            <DropdownCloseSVG/>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </div>
                </div>

                }


            {opened &&
                <div className={className}>
                    {optionalItems}
                </div>}

        </div>

    </>
}
export default WidgetSmartSearch